import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Comment } from './types';
import { cn } from "@/lib/utils";

interface CommentsListProps {
  comments: Comment[];
}

const CommentsList = React.memo(({ comments = [] }: CommentsListProps) => (
  <div className="space-y-6">
    {comments.length === 0 ? (
      <p className="text-gray-400 text-sm">No comments yet. Be the first to comment!</p>
    ) : (
      comments.map((comment) => (
        <div key={comment.id} className="flex gap-4">
          <Avatar className={cn(
            "h-8 w-8",
            comment.user.is_admin && "ring-4 ring-[#F97316]",
            comment.user.is_premium && "ring-4 ring-[#E5DEFF]",
            !comment.user.is_admin && !comment.user.is_premium && "ring-2 ring-primary/20"
          )}>
            <AvatarImage src={comment.user.avatar} />
            <AvatarFallback>{comment.user.name[0]}</AvatarFallback>
          </Avatar>
          <div className="flex-1 space-y-1">
            <div className="flex items-center gap-2">
              <Link 
                to={`/profile/${comment.user.username}`} 
                className="font-medium hover:text-primary transition-colors"
              >
                @{comment.user.username}
              </Link>
              <span className="text-sm text-gray-400">{comment.timestamp}</span>
            </div>
            <p className="text-sm text-gray-200">{comment.text}</p>
            <div className="flex items-center gap-2">
              <Button variant="ghost" size="sm" className="text-gray-400 hover:text-white">
                ♥ {comment.likes}
              </Button>
              <Button variant="ghost" size="sm" className="text-gray-400 hover:text-white">
                Reply
              </Button>
            </div>
          </div>
        </div>
      ))
    )}
  </div>
));

CommentsList.displayName = 'CommentsList';

export default CommentsList;